module.exports = __webpack_public_path__ + "img/方块中级大师@3x.945bc3ac.png";